import api from 'api';

export const loadReleaseVersion = api('GET /release.json', {
  baseURL: `${process.env.REACT_APP_PUBLIC_URL}`,
});
